var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"user detail-page"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-content"},[_c('user-form',{attrs:{"mode":"update"}})],1)])])}
var staticRenderFns = []

export { render, staticRenderFns }